import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SidebarMenuItem } from 'components/molecules';
import { SidebarFooterProps, MenuItem } from 'types/components.types';

const SidebarFooter: React.FC<SidebarFooterProps> = ({
  footerItems,
  className = '',
  onLogout,
  isAuthenticated = false,
  isCollapsed = false
}) => {
  const navigate = useNavigate();

  const getDefaultFooterItems = (): MenuItem[] => {
    return [
      {
        id: 'profile',
        icon: 'user',
        text: 'Profile',
        variant: 'default',
        onClick: () => navigate('/profile')
      },
      {
        id: 'about',
        icon: 'info',
        text: 'About Us',
        variant: 'default',
        onClick: () => window.open('http://www.classfi.ai/', '_blank')
      }
    ];
  };

  const items = footerItems || getDefaultFooterItems();

  return (
    <div className={`${isCollapsed ? 'p-2' : 'p-4'} flex flex-col gap-0 ${className}`}>
      {items.map((item) => (
        <SidebarMenuItem
          key={item.id}
          icon={item.icon}
          text={item.text}
          variant={item.variant}
          onClick={item.onClick}
          isCollapsed={isCollapsed}
        />
      ))}
      {isAuthenticated && onLogout && (
        <SidebarMenuItem
          icon="logout"
          text="Logout"
          variant="default"
          onClick={onLogout}
          isCollapsed={isCollapsed}
          className="text-red-500 hover:bg-red-50"
        />
      )}
    </div>
  );
};

export default SidebarFooter;
